import { Injectable } from '@angular/core';
import { DocumentLoaderGuard } from '../../../service/document-loader.guard';
import { QualityDocumentService } from '../../../service/document-quality.service';
import { OrderDetailModel, OrderLockedBy } from '../../../state/model/order-detail.model';
import { Router } from '@angular/router';
import { BroadcastService, CONTENT_LOADER_EVENT, UserContextModel } from '@cv-invision/core';
import { Subject } from "rxjs";

@Injectable()
export class OverviewSubHeaderService {
	lockedBy: OrderLockedBy;
	user: UserContextModel;
	orderLocked = {
		locked: false,
		byTheUser: false
	};
	subheaderEvents = new Subject();

	constructor(
		private documentOrder: DocumentLoaderGuard,
		private qualityService: QualityDocumentService,
		private router: Router,
		private broadcastService: BroadcastService
	) {}

	/**
	 * get again the order data
	 * @param orderId
	 */
	recallaNewOrder(orderId: number): void {
		this.showLoader(true);
		this.qualityService.forceReloadForCurrentPDF();
		this.qualityService
			.setOrderToReview(orderId)
			.subscribe((orderDetailModel: OrderDetailModel) => {
				this.documentOrder
					.setDocumentOrderToReview(orderDetailModel)
					.then((isReadyToReview: boolean) => {
						this.showLoader(false);
						if (!isReadyToReview) {
							this.router.navigate(['/intelligence/inbox']);
						}
					});
			});
	}

	/**
	 * Show/Hide the Loader
	 * @param isShowing
	 */
	private showLoader(isShowing: boolean): void {
		this.broadcastService.broadcast({
			name: CONTENT_LOADER_EVENT,
			event: {
				isLoader: isShowing,
				message: 'Getting New Order data'
			}
		});
	}

	/**
	 *
	 * @param user
	 * @returns
	 */
	getOrderMsg(user: any, isLock = true): string {
		let msg = `Order was ${isLock ? 'locked':'unlocked'} by `;
		if (user.firstName) {
			msg += `user ${user.firstName} ${user.lastName || ''}`;
		} else {
			msg += 'system';
		}

		return msg;
	}

	/**
	 * Set lockedBy variable
	 * @param lockedBy
	 */
	setOrderLockedBy(lockedBy: OrderLockedBy, currentUser: UserContextModel): void {
		this.lockedBy = lockedBy;
		this.user = currentUser;

		if (this.lockedBy){
			if (this.lockedBy.id) {
				this.orderLocked.locked = true;

				if (this.lockedBy.id === this.user.id) {
					this.orderLocked.byTheUser = true;
				} else {
					this.orderLocked.byTheUser = false;
				}
			} else {
				this.orderLocked.locked = false;
				this.orderLocked.byTheUser = false;
			}
		} else {
			this.orderLocked.locked = false;
			this.orderLocked.byTheUser = false;
		}
	}
}
